// convert POSIX locale format (with underscores, e.g. en_US)
// to BCP 47 standard used by Intl.NumberFormat (with hyphens, e.g. en-US)
export const getFormatLocale = (locale: string) => locale.replace('_', '-')
